import Image from 'next/image';
import parse from '@/components/helper/image';
import style from '@/styles/services.module.css';
import Link from '@/components/helper/link';

export default function BoatMasonry({ items = [] }) {
  const classMap = [
    '',
    '',
    '',
    '',
    'lg:row-span-2 lg:col-span-2',
    'lg:row-span-2 lg:col-span-2',
  ];
  const a = items.slice(0, 6);
  return (
    <ul
      className="grid grid-flow-col lg:grid-flow-row grid-rows-1 lg:grid-rows-3 lg:grid-cols-4 lg:gap-2 overflow-y-hidden overflow-x-auto lg:overflow-hidden lg:h-[500px]"
    >
      {a.map((item, k) => (
        <li
          key={k}
          className={`${classMap[k]} w-slider-item h-slider-item lg:w-full lg:h-full text-left overflow-hidden `}
        >
          <Link
            href={`/yacht/${item.slug}`}
          >
            <a
              className="relative font-bold flex flex-col items-center justify-end h-full duration-500 ease-in-out transition-spacing group"

            >
              <div
                className={
                  k > 4 - 1
                    ? 'absolute text-primary z-20 bg-action group-hover:shadow-lg left-0 bottom-0 w-full transition-all px-3 py-4 text-xl duration-500 ease-in-out text-center lg:text-left'
                    : 'absolute text-primary z-20 bg-action group-hover:shadow-lg left-0 top-0 w-full transition-all px-3 py-2 duration-500 ease-in-out text-center lg:text-left'
                }
              >
                <span className="block mb-0 leading-5 text-center ">{item.title}</span>
              </div>
              <div
                className={`relative ${style.imageWrapper}`}
              >
                <Image
                  alt={item.name}
                  title={item.name}
                  src={parse(item.photo_url, { w: 2000 })}
                  layout="fill"
                  objectFit="cover"
                />
              </div>
            </a>
          </Link>
        </li>
      ))}
    </ul>
  );
}
